import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Shell, Spinner } from '../components/Shell';
import { API_BASE_URL, K, clearPay, load, save } from '../lib/api';
import { buildReport, downloadHtml, fetchPaid, fullPayload } from '../lib/report';

export default function PaymentSuccessPage() {
  const [state, setState] = useState('loading');
  const [err, setErr] = useState('');
  const [html, setHtml] = useState('');
  const [fname, setFname] = useState('');

  useEffect(() => {
    const run = async () => {
      const q = new URLSearchParams(window.location.search);
      const tokenUrl = q.get('token');
      if (tokenUrl) save(K.payToken, tokenUrl);

      if (q.get('txnid') && q.get('hash')) {
        const params = {};
        q.forEach((v, k) => { params[k] = v; });
        const vRes = await fetch(`${API_BASE_URL}/payu/verify`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(params),
        });
        const vData = await vRes.json();
        if (!vData.verified) { setState('error'); setErr('Verification failed'); return; }
        save(K.payToken, vData.token || '');
      }

      const records = JSON.parse(load(K.records, '[]'));
      const ctx = JSON.parse(load(K.ctx, '{}'));
      const token = load(K.payToken);
      if (!records.length || !ctx.query) { setState('error'); setErr('Session expired'); return; }

      const body = fullPayload(token, ctx, records);
      if (!body) { setState('error'); setErr('Missing token'); return; }

      const res = await fetchPaid(body);
      if (!res.ok) {
        let m = 'Could not load report';
        try { m = (await res.json()).error || m; } catch (_) {}
        setState('error'); setErr(m); return;
      }
      const data = await res.json();
      const full = data.results || [];
      if (!full.length) { setState('error'); setErr('No records'); return; }

      const fn = `Zameenmahiti_${ctx.query}.html`;
      const h = buildReport(full, ctx);
      setHtml(h);
      setFname(fn);
      downloadHtml(h, fn);
      setState('done');
    };
    run();
  }, []);

  if (state === 'loading') {
    return (
      <Shell narrow>
        <Spinner />
        <p className="text-center text-sm text-muted">Preparing your report…</p>
      </Shell>
    );
  }

  if (state === 'error') {
    return (
      <Shell narrow>
        <div className="card text-center">
          <p className="text-red-500 font-medium">{err}</p>
          <Link to="/" className="btn mt-4 inline-flex">Search again</Link>
        </div>
      </Shell>
    );
  }

  return (
    <Shell narrow>
      <div className="card-accent text-center animate-in">
        <div className="mx-auto w-14 h-14 rounded-full bg-gradient-to-br from-emerald-400 to-brand flex items-center justify-center text-white text-2xl font-bold shadow-soft mb-4">
          ✓
        </div>
        <h1 className="text-xl font-bold">Payment successful</h1>
        <p className="text-sm text-muted mt-2">Your report should download automatically.</p>
        <button type="button" onClick={() => downloadHtml(html, fname)} className="btn w-full mt-6">Download again</button>
        <Link to="/reports" className="btn-ghost w-full mt-2 inline-flex justify-center">My reports</Link>
        <Link to="/" onClick={clearPay} className="text-xs text-muted mt-4 inline-block hover:text-brand transition-colors">
          New search
        </Link>
      </div>
    </Shell>
  );
}
